import React from 'react'
export const notificationAlert = React.createRef()